import { useRef, useCallback } from "react";

export const HONEYPOT_NAME = "website";
const MIN_FILL_TIME_MS = 2000; // 2 seconds — catches bots, allows fast human entry

export const useSpamProtection = () => {
  const startTimeRef = useRef<number>(Date.now());

  const checkHoneypot = useCallback((formData: FormData): boolean => {
    const honeypot = formData.get(HONEYPOT_NAME);
    return !honeypot || honeypot.toString().trim() === "";
  }, []);

  const checkTiming = useCallback((): boolean => {
    const elapsed = Date.now() - startTimeRef.current;
    return elapsed >= MIN_FILL_TIME_MS;
  }, []);

  const validate = useCallback((formData: FormData): { ok: boolean; reason?: string } => {
    if (!checkHoneypot(formData)) {
      return { ok: false, reason: "honeypot" };
    }
    if (!checkTiming()) {
      return { ok: false, reason: "too_fast" };
    }
    return { ok: true };
  }, [checkHoneypot, checkTiming]);

  return { validate, honeypotName: HONEYPOT_NAME };
};
